document.addEventListener('DOMContentLoaded', () => {
	const leftYearContainers = document.querySelectorAll('.timeline-left .timeline-year');
	const rightYearSections = document.querySelectorAll('.timeline-right .timeline-year[data-year]');
	const timelineSelect = document.querySelector('select[name="timeline"]');

	function activateYear(year) {
		leftYearContainers.forEach(container => {
			const h4 = container.querySelector('[data-year]');
			const containerYear = h4 ? h4.getAttribute('data-year') : null;

			container.classList.toggle('active', containerYear === year);
		});

		// Sync select dropdown if it exists
		if (timelineSelect && timelineSelect.value !== year) {
			timelineSelect.value = year;
		}
	}

	// ✅ Smooth scroll to first matching right-side year
	function scrollToYear(year) {
		const target = document.querySelector(
			`.timeline-right .timeline-year[data-year="${year}"]`
		);

		if (target) {
			target.scrollIntoView({
				behavior: 'smooth',
				block: 'start'
			});
		}
	}

	// ✅ Make LEFT YEARS CLICKABLE
	leftYearContainers.forEach(container => {
		const h4 = container.querySelector('h4[data-year]');
		if (!h4) return;

		h4.style.cursor = 'pointer';

		h4.addEventListener('click', () => {
			const year = h4.getAttribute('data-year');
			activateYear(year);
			scrollToYear(year);
		});
	});

	// ✅ SELECT DROPDOWN → SCROLL
	if (timelineSelect) {
		timelineSelect.addEventListener('change', (e) => {
			const year = e.target.value;
			activateYear(year);
			scrollToYear(year);
		});
	}

	// ✅ SAFETY: Set first active on load
	if (leftYearContainers.length > 0) {
		const firstYear = leftYearContainers[0]
			.querySelector('[data-year]')
			?.getAttribute('data-year');

		if (firstYear) {
			activateYear(firstYear);
			if (timelineSelect) timelineSelect.value = firstYear;
		}
	}

	// ✅ OBSERVER STILL HANDLES SCROLL-BASED STATE
	const observer = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				const year = entry.target.getAttribute('data-year');
				activateYear(year);
			}
		});
	}, {
		root: null,
		threshold: 0,
		rootMargin: '-10% 0px -80% 0px'
	});

	rightYearSections.forEach(section => {
		observer.observe(section);
	});
});



